import { registerSW } from 'virtual:pwa-register';

/** How often coming back to the app looks for a new version (a small no-cache fetch of sw.js). */
const UPDATE_CHECK_MS = 5 * 60 * 1000;

/**
 * Registers the offline service worker (production web builds only). A new version is downloaded
 * in the background and applied the next time the app is hidden while no lawn is in progress, so
 * an update never interrupts play. Saves live in localStorage, so the reload loses nothing.
 *
 * The browser only looks for a new version when the page loads, and an installed app can stay in
 * memory for days (owner, 2026-10-21: the site still said "Coming soon to the App Store" after the
 * link went live), so coming back to the app looks too.
 */
export function registerOfflineSupport(isPlaying: () => boolean): void {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;
  let updateReady = false;
  let lastCheck = Date.now();
  let registration: ServiceWorkerRegistration | undefined;
  const update = registerSW({
    immediate: true,
    onNeedRefresh: () => {
      updateReady = true;
    },
    onRegisteredSW: (_url, r) => {
      registration = r;
    },
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (updateReady && !isPlaying()) void update(true);
      return;
    }
    if (!registration || updateReady || Date.now() - lastCheck < UPDATE_CHECK_MS) return;
    lastCheck = Date.now();
    registration.update().catch(() => {
      // Offline: the next return looks again.
    });
  });
}
